import React from 'react';
import { motion } from 'framer-motion';
export function MechanismSection() {
  return <section className="py-12 md:py-24 bg-blush relative overflow-hidden" data-id="element-86">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none" data-id="element-87">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full border border-rosegold" data-id="element-88"></div>
        <div className="absolute top-1/2 -left-32 w-64 h-64 rounded-full border border-rosegold" data-id="element-89"></div>
      </div>

      <div className="max-w-4xl mx-auto px-5 lg:px-8 relative z-10 text-center" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-91">
          <span className="text-rosegold font-medium tracking-widest uppercase text-xs md:text-sm mb-3 md:mb-4 block" data-id="element-92">
            El Mecanismo Único
          </span>
          <h2 className="text-2xl md:text-5xl font-serif text-charcoal mb-5 md:mb-8 leading-tight" data-id="element-93">
            El Protocolo de Micro-Hipopresivos es la "Llave Maestra" de tu
            recuperación.
          </h2>

          <div className="bg-white/60 backdrop-blur-sm p-5 md:p-12 rounded-2xl shadow-sm border border-white/50" data-id="element-94">
            <svg className="w-10 h-10 md:w-16 md:h-16 mx-auto mb-4 md:mb-6 text-rosegold" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1" data-id="element-95">
              <path strokeLinecap="round" strokeLinejoin="round" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-96" />
            </svg>
            <p className="text-base md:text-xl text-charcoal/80 leading-relaxed mb-4 md:mb-6" data-id="element-97">
              A diferencia del ejercicio convencional, esta técnica utiliza la
              presión negativa (vacío abdominal) para succionar los órganos
              hacia arriba y obligar a tus músculos internos a cerrarse
              automáticamente.
            </p>
            <p className="text-base md:text-xl text-charcoal/80 leading-relaxed font-medium" data-id="element-98">
              No necesitas pesas, ni ropa de gimnasio, solo 15 minutos en la
              comodidad de tu casa antes de que los niños despierten.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}